import { frontendURL } from '../../../helper/URLHelper';
import HomeDashboard from './HomeDashboard.vue';
import ReportsWrapper from '../settings/reports/components/ReportsWrapper.vue';
import { ROLES } from 'dashboard/constants/permissions.js';

import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/home-dashboard'),
    component: ReportsWrapper,
    children: [
      {
        path: '',
        redirect: to => {
          return { name: 'home-dashboard', params: to.params };
        },
      },
      {
        path: '',
        name: 'home-dashboard',
        component: HomeDashboard,
        meta: {
          permissions: [...ROLES],
        },
      },
    ],
  },
];
